import { Instagram, Youtube } from "lucide-react";
import { LINKS } from "@/lib/links";

const MAIN = [
  { name: "Home", href: "/" },
  { name: "Mappa", href: LINKS.TEMPIO_VIVO },
  { name: "Sfida del Deserto", href: LINKS.DESERTO },
  { name: "Tempio", href: LINKS.TEMPIO_APP },
  { name: "Donna", href: LINKS.DONNA_VIRTUOSA },
  { name: "Uomo", href: LINKS.UOMO_BIBLICO },
];

const SECONDARY = [
  { name: "Chi siamo", href: "#chi-siamo" },
  { name: "Contatti", href: "#contatti" },
  { name: "Privacy", href: "#" },
  { name: "Termini", href: "#" },
  { name: "Cookie", href: "#" },
];

const ext = (href) => (href.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {});

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B0B0B] border-t border-[#262626]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <p className="font-display text-lg text-[#F7F4EE]">
          FEDE <span className="text-[#C9A75D]">&</span> FITNESS ITALIA
        </p>
        <p className="mt-3 text-sm text-[#D8C7AA]/70 leading-relaxed">
          Life Coaching Cristiano
          <br />
          Metodo Tempio Vivo
        </p>
        <div className="flex gap-4 mt-6">
          <a
            data-testid="footer-instagram"
            href={LINKS.INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            className="text-[#D8C7AA]/70 hover:text-[#C9A75D] transition-colors"
          >
            <Instagram size={18} />
          </a>
          <a data-testid="footer-tiktok" href={LINKS.TIKTOK} {...ext(LINKS.TIKTOK)} aria-label="TikTok" className="text-[#D8C7AA]/70 hover:text-[#C9A75D] transition-colors text-sm font-semibold">
            TikTok
          </a>
          <a data-testid="footer-youtube" href={LINKS.YOUTUBE} {...ext(LINKS.YOUTUBE)} aria-label="YouTube" className="text-[#D8C7AA]/70 hover:text-[#C9A75D] transition-colors">
            <Youtube size={18} />
          </a>
        </div>
      </div>

      <div>
        <p className="text-[0.65rem] uppercase tracking-[0.25em] text-[#C9A75D] mb-5">Esplora</p>
        <ul className="space-y-3">
          {MAIN.map((l) => (
            <li key={l.name}>
              <a href={l.href} {...ext(l.href)} className="text-sm text-[#F7F4EE]/70 hover:text-[#F7F4EE] transition-colors">
                {l.name}
              </a>
            </li>
          ))}
          <li>
            <a href={LINKS.SHOP} target="_blank" rel="noreferrer" className="text-sm text-[#C9A75D] hover:text-[#F7F4EE] transition-colors">
              Shop ↗
            </a>
          </li>
        </ul>
      </div>

      <div>
        <p className="text-[0.65rem] uppercase tracking-[0.25em] text-[#C9A75D] mb-5">Informazioni</p>
        <ul className="space-y-3">
          {SECONDARY.map((l) => (
            <li key={l.name}>
              <a href={l.href} className="text-sm text-[#F7F4EE]/70 hover:text-[#F7F4EE] transition-colors">
                {l.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-[#262626] py-6 text-center">
      <p className="text-xs text-[#D8C7AA]/45">© {new Date().getFullYear()} Fede & Fitness Italia. Tutti i diritti riservati.</p>
    </div>
  </footer>
);
